import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/pet-profile/components/PetProfileInteractive.tsx");
